
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class PazSearchBoxSelect extends Vue {
  public search: string = '';
  public searchInAttr: boolean = false;
  public searchAdvInAttr: boolean = false;

  @Prop({ default: '' }) selectLabel?: string;
  @Prop({ default: false }) showAttrCheckbox!: boolean;
  @Prop({ default: false }) showAdvAttrCheckbox?: boolean;
  @Prop({ default: '' }) checkboxTooltip?: string;
  @Prop({ default: 'mdi-table-search' }) selectAppendIcon?: string;


  onSearch() {
    this.$emit(
      'onSearch', { search: this.search, searchInAttr: this.searchInAttr, searchAdvInAttr: this.searchAdvInAttr })
  }

}//
